import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import colors from 'vuetify/es5/util/colors'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);




export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        // primary: colors.lightBlue.darken2,
        // primary: colors.lightBlue.darken3,
        primary: colors.blueGrey.base,
        // primary: colors.pink.base,
        secondary: colors.lightBlue.base,
        accent: colors.lightBlue.accent3,
        info: colors.blue.lighten1,
        // error: colors.pink.base,
        // error: colors.red.accent3,
        error: colors.red.base,
        success: colors.lightGreen.darken1,
        warning: colors.amber.darken1
      },
      dark: {
        primary: colors.lightBlue.darken2,
        secondary: colors.lightBlue.base,
        accent: colors.lightBlue.accent3,
        info: colors.blue.lighten1,
        // error: colors.pink.base,
        // error: colors.red.accent3,
        error: colors.red.base,
        success: colors.lightGreen.darken1,
        warning: colors.amber.darken1
      }
    },
  },
});
